







































































































































import Vue, { VueConstructor } from 'vue'
import NoDataContent from '@/pages/common/parts/no-data-content/NoDataContent.vue'
import ActionsButton from '@/pages/common/parts/actions/ActionsButton.vue'
import TooltipFilter from '@/pages/callback/comments-on-lessons/parts/TooltipFilter.vue'
import GeneralFilter from '@/pages/common/general-filter/GeneralFilter.vue'
import LoaderBig from '@/pages/common/parts/internal-loader-blocks/BigLoader.vue'
import TooltipCell from '@/pages/common/parts/tooltip-cell/TooltipCell.vue'
import TableHeader from '@/pages/common/parts/table-header/TableHeader.vue'
import ContextMenu from '@/pages/common/parts/context-menu/ContextMenu.vue'
import CommentsOnLessonsHeader from '@/pages/callback/comments-on-lessons/parts/CommentsOnLessonsHeader.vue'
import {
  ActionsItem,
  CommonInteractedItemParams,
  DisplayContextMenuPayload,
  HttpOptionsType,
  RefsType,
} from '@/pages/common/types'
import VueEvents from 'vue-events'
import { Vuetable, VuetablePagination, VuetableFieldCheckbox } from 'vuetable-2'
import {
  $visibility,
  toggleVisibility,
} from '@/pages/callback/comments-on-lessons/model/tooltip-filter.model'
import {
  $isLoading,
  $refreshPage,
  commentsOnLessonsPageMounted,
} from '@/pages/callback/comments-on-lessons/model/callback-comments-on-lessons-page.model'
import {
  callbackCommentsOnLessonsFilters,
  commentsOnLessonsPageParams,
  exportCommentsOnLessonsList,
} from '@/pages/callback/comments-on-lessons/model/callback-comments-on-lessons-filters.model'
import { $permissions } from '@/features/session'
import { DEFAULT_ID } from '@/pages/common/constants'
import { ContextMenuType } from '@/pages/common/parts/context-menu/types'
import {
  searchFieldsData,
  CommentsOnLessonsTableFields,
} from '@/pages/callback/comments-on-lessons/model/constants'
import { config } from '@/config'
import { getActionsDisplayConditions } from '@/pages/common'
import { getCommentsOnLessonsActions } from '@/pages/callback/comments-on-lessons/constants'
import {
  combineRouteQueries,
  computeSortParam,
  getFileForPreview,
  isQueryParamsEquelToPage,
} from '@/features/lib'
import { axiosClient } from '@/lib/request'
import { reset } from '@/pages/common/general-filter/general-filter.model'
import { navigatePush } from '@/features/navigation/navigationMethods'
import { noInternetToastEvent } from '@/features/toasts/toasts.model'
import { showContextMenu } from '@/pages/common/parts/context-menu/context-menu.model'
import dayjs from 'dayjs'
import { patchCommentOnLessonFX } from '@/features/api/callback/patch-comment-on-lesson'
import { UpdateCommentOnLessonQueryBody } from '@/features/api/callback/types'
import PreviewFile from '@/ui/preview-file/PreviewFile.vue'
import BaseButton from '@/ui/button/BaseButton.vue'
import { UploadMediaResponse } from '@/features/api/media/types'
import { loadModal } from '@/ui/preview-file/preview-file.model'

Vue.use(VueEvents)
Vue.component('VuetableFieldCheckbox', VuetableFieldCheckbox)

export default (Vue as VueConstructor<Vue & { $refs: RefsType }>).extend({
  name: 'CommentsOnLessonsListPage',
  components: {
    BaseButton,
    PreviewFile,
    Vuetable,
    VuetablePagination,
    CommentsOnLessonsHeader,
    ContextMenu,
    TableHeader,
    TooltipCell,
    LoaderBig,
    GeneralFilter,
    TooltipFilter,
    ActionsButton,
    NoDataContent,
  },
  effector: {
    $visibility,
    $isLoading,
    $refreshPage,
    $filterParams: callbackCommentsOnLessonsFilters.store.$filterParams,
    $pageParams: commentsOnLessonsPageParams.store.$pageParams,
    $treeView: commentsOnLessonsPageParams.store.treeView,
    $currentPage: commentsOnLessonsPageParams.store.currentPage,
    $permissions,
  },
  data() {
    return {
      interactedItemId: DEFAULT_ID,
      contextMenuType: 'item' as ContextMenuType,
      contextMenuClickedCoordinates: { x: 0, y: 0 },
      searchFields: searchFieldsData,
      fields: CommentsOnLessonsTableFields,
      total: 0,
      selectedRows: [] as number[],
      showDeleteModalType: 'students',
    }
  },
  computed: {
    apiUrl(): string {
      return `${config.BACKEND_URL}/api/lesson-app/lessons/commentaries/list/`
    },
    selectedIds(): number[] {
      if (this.selectedRows.length && !this.$treeView) {
        return this.selectedRows
      }
      if (this.interactedItemId !== DEFAULT_ID) {
        return [this.interactedItemId]
      }
      return []
    },
    tableHeaderItems(): ActionsItem[] {
      const displayConditions = getActionsDisplayConditions('tableHeader', this.selectedRows.length)
      return getCommentsOnLessonsActions(displayConditions, this.selectedRows)
    },
  },
  watch: {
    $refreshPage: {
      handler(newVal) {
        if (newVal) this.$refs.vuetable.reload()
        this.removeSelection()
      },
    },
    $pageParams: {
      handler(newVal) {
        if (!isQueryParamsEquelToPage(this.$route.query, newVal)) {
          this.$router.replace(combineRouteQueries(this.$route.query, newVal))
        }
      },
    },
    $treeView: {
      handler(newVal) {
        if (newVal) this.removeSelection()
      },
    },
  },
  methods: {
    dayjs,
    changeFilter: callbackCommentsOnLessonsFilters.methods.changeFilter,
    resetFilters: callbackCommentsOnLessonsFilters.methods.resetFilters,
    applyFilters: callbackCommentsOnLessonsFilters.methods.applyFilters,
    toggleTreeView: commentsOnLessonsPageParams.methods.toggleTreeView,
    changePage: commentsOnLessonsPageParams.methods.changePage,
    queryToParams: commentsOnLessonsPageParams.methods.queryToParams,
    toggleVisibility,
    exportCommentsOnLessonsList,
    async myFetch(apiUrl: string, httpOptions: HttpOptionsType) {
      const request = axiosClient.get(apiUrl, {
        params: { ...httpOptions.params, sort: computeSortParam(httpOptions.params.sort) },
      })
      return request
    },
    onPaginationData(paginationData: any) {
      this.total = paginationData.total
      this.$refs.pagination.setPaginationData(paginationData)
      this.removeSelection()
    },
    onChangePage(page: any) {
      this.$refs.vuetable.changePage(page)
      this.changePage(page)
    },
    onFilterSet() {
      this.applyFilters()
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    },
    onFilterReset() {
      this.resetFilters()
      toggleVisibility(false)
      reset() // search string and field
      Vue.nextTick(() => this.$refs.vuetable.reload())
    },
    editComment() {
      const payload = this.selectedIds[0]
      navigatePush({
        name: 'edit-comment-on-lesson',
        params: { id: `${payload}` },
      })
    },
    setShownOrAttached(type: 'shown' | 'attached', value: boolean) {
      const body: UpdateCommentOnLessonQueryBody = {
        commentaries: this.selectedIds,
        [`is_${type}`]: value,
      }
      patchCommentOnLessonFX({ body }).then(() => {
        Vue.nextTick(() => this.$refs.vuetable.reload())
      })
    },
    removeSelection() {
      this.$refs.vuetable.selectedTo = []
      this.selectedRows = []
    },
    handleLoadError(res: any) {
      if (!res.response) {
        noInternetToastEvent()
      }
    },
    headerActionsButtonClick(event: MouseEvent) {
      this.handleActionsClick({
        data: { id: this.selectedIds[0] },
        event,
        type: 'header-actions',
      })
    },
    tableActionsButtonClick(event: MouseEvent, id: number) {
      this.handleActionsClick({
        data: { id },
        event,
        type: 'item',
      })
    },
    handleActionsClick({ data, event, type }: CommonInteractedItemParams) {
      this.handleInteractedItemData(data)
      this.displayContextMenu({ id: data.id, type, coordinates: { x: event.x, y: event.y } })
    },
    handleRightClick({ data, event, type }: CommonInteractedItemParams) {
      event.preventDefault()
      this.handleInteractedItemData(data)
      this.displayContextMenu({ id: data.id, type, coordinates: { x: event.x, y: event.y } })
    },
    handleInteractedItemData(data: { id: number }) {
      this.interactedItemId = data.id
    },
    displayContextMenu({ id, type, coordinates: { x, y } }: DisplayContextMenuPayload) {
      this.interactedItemId = id
      this.contextMenuType = type
      this.contextMenuClickedCoordinates = { x, y }
      showContextMenu()
    },
    handleRowClick(res: any) {
      if (res.event.target.closest('.actions-activator')) return
      const { selectedTo } = this.$refs.vuetable
      if (selectedTo.length === 0) selectedTo.push(res.data.id)
      else if (selectedTo.find((el: number) => el === res.data.id)) {
        selectedTo.splice(selectedTo.indexOf(res.data.id), 1)
      } else selectedTo.push(res.data.id)
      this.selectedRows = this.$refs.vuetable.selectedTo
    },
    allToggled(isSelected: boolean) {
      if (isSelected) this.selectedRows = this.$refs.vuetable.selectedTo
      else this.selectedRows = []
    },
    download(file: UploadMediaResponse) {
      getFileForPreview(file.file, true).then((blob) => {
        if (!blob) {
          return
        }

        const splitFileName = file.file_name.split('.')
        loadModal({
          file: blob,
          format: splitFileName[splitFileName.length - 1],
          filename: splitFileName.slice(0, -1).join(''),
        })
      })
    },
    getShortFileName(fileName: string) {
      return `${fileName.substring(0, 10)}... ${fileName.substring(fileName.length - 3)}`
    },
  },
  mounted() {
    commentsOnLessonsPageMounted()
  },
  created() {
    this.queryToParams(this.$route.query)
  },
  destroyed() {
    this.resetFilters()
  },
})
